import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import {
  USER_FORM_EMAIL_FIELD_MAX_LENGTH,
  USER_FORM_FIELD_NAME_EMAIL,
} from '../../../../User'

import * as styles from '../InhabitantFormFields.module.css'

function EmailField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Inhabitant.EmailLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={USER_FORM_EMAIL_FIELD_MAX_LENGTH}
      name={USER_FORM_FIELD_NAME_EMAIL}
      placeholder={t('Inhabitant.EmailPlaceholderKey')}
      wrapperClassName={styles.fieldWrapper}
    />
  )
}

export default EmailField
